import Meta from 'src/components/meta/Meta';

const ContactUsMeta = () => <Meta
  title="Contact Us | BrickX"
  description="If you have any questions, we'd be happy to help. We're available Monday to Friday between 8:30am - 6:00pm (AEST) at info.brickx.com"
/>;

export default ContactUsMeta;
